module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Head-fmh"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_7",
      "title": "7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-No-Indent-fmtx1"
  }, [_vm._v("The American Craft series and this book in particular would not have been possible without the support of many people, some of whom are specifically thanked below:")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Editor Claire Eddy, whose patience during my recent tribulations gave me the time and confidence to write this novel properly.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Editorial assistants Bess Cozby and Kristin Temple for going pirate hunting with me.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Agent Robert Thixton for continuing to persevere.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Dominick Saponaro, Irene Gallo, and Peter Lutjen for the joy of seeing such wonderful cover illustrations and designs for my work.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Copy editors Anna Chang, Ivy McFadden, and Debbie Friedman for their obsession for detail.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("The members of the Writers Group from Hell for journeying for a year with me from one chunk of text to the next, for the third time.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("My brother Bill Doyle, whose research on climbing above twenty thousand feet was very important (so many ways to fail!).")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("My partner, Beth Delaney, who kept me alive so I could finish this trilogy.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Moira Fitzgibbons, who helped again with Latin, and who also advised on the appropriate handling of old manuscripts.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Colleen Cahill and the Library of Congress for the use of their map collection.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Robert O’Donoghue, Shannon McRae, and Angie Greene for their assistance with the prologue.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Tom Zanol for a helpful bit of Italian, and for lending me his name for the first book.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_8",
      "title": "8"
    }
  }, [_vm._v("All the indie book bloggers who mentioned my work or allowed me to be their guest.")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Among the many references I used, I’m particularly indebted to Lawrence Sutin’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Do What Thou Wilt: A Life of Aleister Crowley")]), _vm._v(" (St. Martin’s Press, 2000).")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Most of all, I’m grateful to the readers who’ve followed my craftspeople through these three books.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Thank you!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0